import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AdvancedCommerceListingSortComponentDef, AdvancedCommerceStore } from '@df/module-advanced-commerce';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { NListing } from 'projects/app-default/src/app/catalog/ui/listing/product-listing.interface';
import { DropdownComponent } from 'projects/app-default/src/app/ui/display/dropdown/dropdown.component';

@Component({
    selector: 'ac-product-listing-sort',
    templateUrl: '../../../../catalog/ui/listing/product-listing-sort.html',
    standalone: true,
    imports: [DropdownComponent, TranslationModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AdvancedCommerceProductListingSortComponent extends AdvancedCommerceListingSortComponentDef implements NListing.ISort {
    @Input()
    displayAs: 'dropdown' | 'buttons' = 'dropdown';

    // fake input to make it work on old template without ac
    @Input()
    sort = true;

    isSelected(option: AdvancedCommerceStore.Sorting.Item): boolean {
        return option.active;
    }

    get options() {
        return this.store.sortingEntities() || [];
    }

    sortBy(option: AdvancedCommerceStore.Sorting.Item): void {
        this.store.sortingBy(option);
    }
}
